import { QueryCache, QueryClient } from '@tanstack/react-query';

let client: QueryClient | null = null;

export const createQueryClient = () =>
    new QueryClient({
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: false,
                retry: 1,
            },
            mutations: {
                retry: 1,
            },
        },
        queryCache: new QueryCache({}),
    });

// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
export const getQueryClient = () => (client ??= createQueryClient());
